import { isObject } from './isObject';
/**
 * Returns true if the given value is a child of a plain object created with {} or new Object()
 * @param value
 */
export function isPlainObject(value) {
    return isObject(value) &&
        Object.prototype.toString.call(value) === '[object Object]' &&
        value !== null &&
        typeof value.constructor === 'function' &&
        value.constructor.prototype.hasOwnProperty('isPrototypeOf');
}
//# sourceMappingURL=isPlainObject.js.map